'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18nReact = require('I18n.React.FormattedHTMLMessage');

var _I18nReact2 = _interopRequireDefault(_I18nReact);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _underscore = require('underscore');

var _EmailAddress = require('PatternValidationJS/patterns/EmailAddress');

var _EmailAddress2 = _interopRequireDefault(_EmailAddress);

var _icons = require('icons/icons');

var icons = _interopRequireWildcard(_icons);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UIMedia = require('UIComponents/layout/UIMedia');

var _UIMedia2 = _interopRequireDefault(_UIMedia);

var _UIMediaBody = require('UIComponents/layout/UIMediaBody');

var _UIMediaBody2 = _interopRequireDefault(_UIMediaBody);

var _UIMediaRight = require('UIComponents/layout/UIMediaRight');

var _UIMediaRight2 = _interopRequireDefault(_UIMediaRight);

var _UITextInput = require('UIComponents/input/UITextInput');

var _UITextInput2 = _interopRequireDefault(_UITextInput);

var _UIFormControl = require('UIComponents/legacy/UIFormControl');

var _UIFormControl2 = _interopRequireDefault(_UIFormControl);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UIIconCircle = require('UIComponents/icon/UIIconCircle');

var _UIIconCircle2 = _interopRequireDefault(_UIIconCircle);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _FadeTransition = require('conversations-core/components/transition/FadeTransition');

var _FadeTransition2 = _interopRequireDefault(_FadeTransition);

var _ChatBubble = require('ui-addon-conversations/components/ChatBubble');

var _ChatBubble2 = _interopRequireDefault(_ChatBubble);

var _Keys = require('conversations-core/constants/Keys');

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'EmailCapture',

  propTypes: {
    coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default).isRequired,
    onSubmit: _react.PropTypes.func.isRequired,
    responderName: _react.PropTypes.string.isRequired,
    hasVisitorEmail: _react.PropTypes.bool,
    emailCaptureMessage: _react.PropTypes.string.isRequired,
    currentRole: _react.PropTypes.oneOf((0, _underscore.values)(_RoleTypes2.default)).isRequired,
    online: _react.PropTypes.bool,
    isAgentReady: _react.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    return {
      email: '',
      error: false,
      success: !!this.props.hasVisitorEmail
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps() {
    if (!this.state.success && this.props.hasVisitorEmail) {
      this.setState({ success: true });
    }
  },
  handleKeyPress: function handleKeyPress(e) {
    if (e.which === _Keys.ENTER) {
      this.handleOnSubmit();
    }
  },
  handleOnChange: function handleOnChange(e) {
    this.setState({
      email: e.target.value,
      error: false
    });
  },
  handleOnSubmit: function handleOnSubmit() {
    var email = this.state.email;


    if (_EmailAddress2.default.test(email)) {
      this.props.onSubmit(email);
      this.setState({ success: true });
    } else {
      this.setState({ error: true });
    }
  },
  getButtonStyle: function getButtonStyle() {
    var accentColor = this.props.coloring.accentColor;

    return { backgroundColor: accentColor, borderColor: accentColor };
  },
  getValidationMessage: function getValidationMessage() {
    if (!this.state.error) {
      return null;
    }

    return _react2.default.createElement(
      'div',
      { className: 'text-center' },
      _react2.default.createElement(_I18nReact2.default, { message: 'input.email.error' })
    );
  },
  renderFormHeader: function renderFormHeader() {
    var _props = this.props,
        online = _props.online,
        isAgentReady = _props.isAgentReady;


    if (online && (isAgentReady || isAgentReady === undefined)) {
      return null;
    }

    return _react2.default.createElement(
      'p',
      { className: 'm-bottom-2' },
      _react2.default.createElement(
        _Small2.default,
        null,
        _react2.default.createElement(
          'b',
          null,
          _react2.default.createElement(_I18nReact2.default, { message: 'input.emailCapture.header' })
        )
      )
    );
  },
  renderForm: function renderForm() {
    var email = this.state.email;


    return _react2.default.createElement(
      'div',
      {
        className: 'email-capture-form email-capture-content-child',
        key: 'email-capture-form'
      },
      this.renderFormHeader(),
      _react2.default.createElement(
        _UIMedia2.default,
        { className: 'email-capture-input-container' },
        _react2.default.createElement(
          _UIMediaBody2.default,
          { className: 'display-flex align-center' },
          _react2.default.createElement(_UITextInput2.default, {
            styled: false,
            value: email,
            placeholder: _I18n2.default.text('input.emailCapture.placeholder'),
            onChange: this.handleOnChange,
            onKeyPress: this.handleKeyPress
          })
        ),
        _react2.default.createElement(
          _UIMediaRight2.default,
          null,
          _react2.default.createElement(
            _UIButton2.default,
            {
              className: 'email-capture-submit-button',
              use: 'tertiary',
              style: this.getButtonStyle(),
              onClick: this.handleOnSubmit
            },
            _react2.default.createElement(_UIIcon2.default, { className: 'center-block', name: icons.SUCCESS })
          )
        )
      )
    );
  },
  renderSuccessState: function renderSuccessState() {
    var _props2 = this.props,
        _props2$coloring = _props2.coloring,
        accentColor = _props2$coloring.accentColor,
        textColor = _props2$coloring.textColor,
        responderName = _props2.responderName,
        online = _props2.online;


    return _react2.default.createElement(
      'div',
      {
        className: 'email-capture-success-state email-capture-content-child',
        key: 'email-capture-success-state'
      },
      _react2.default.createElement(
        'div',
        { className: 'icon-container m-right-2' },
        _react2.default.createElement(_UIIconCircle2.default, {
          name: icons.SUCCESS,
          backgroundColor: accentColor,
          borderColor: accentColor,
          color: textColor,
          size: 12
        })
      ),
      _react2.default.createElement(
        _Small2.default,
        { className: 'm-all-0' },
        _react2.default.createElement(_I18nReact2.default, {
          message: online ? 'input.emailCapture.onlineSuccess' : 'input.emailCapture.offlineSuccess',
          options: { name: responderName }
        })
      )
    );
  },
  renderChatBubble: function renderChatBubble() {
    var _props3 = this.props,
        coloring = _props3.coloring,
        currentRole = _props3.currentRole,
        emailCaptureMessage = _props3.emailCaptureMessage,
        online = _props3.online,
        isAgentReady = _props3.isAgentReady;


    if (online && isAgentReady === true) {
      return _react2.default.createElement(
        'div',
        { className: 'chat-message-content' },
        _react2.default.createElement(
          _ChatBubble2.default,
          {
            coloring: coloring,
            currentRole: currentRole,
            messageRole: _RoleTypes2.default.REP,
            isFirstInGroup: true,
            isLastInGroup: false,
            className: 'm-bottom-4'
          },
          emailCaptureMessage
        )
      );
    }

    return null;
  },
  renderFormOrSuccessState: function renderFormOrSuccessState() {
    if (!this.state.success) {
      return this.renderForm();
    }

    return this.renderSuccessState();
  },
  render: function render() {
    var error = this.state.error;


    return _react2.default.createElement(
      'div',
      null,
      this.renderChatBubble(),
      _react2.default.createElement(
        _UIFormControl2.default,
        {
          error: error,
          className: 'm-x-3',
          validationMessage: this.getValidationMessage()
        },
        _react2.default.createElement(
          'div',
          { className: 'email-capture' },
          _react2.default.createElement(
            _FadeTransition2.default,
            { className: 'email-capture-content' },
            this.renderFormOrSuccessState()
          )
        )
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/components/input/EmailCapture.js
// module id = 276
// module chunks = 0 1